import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { templateActions } from '../../actions';
import { useDispatch } from 'react-redux';
import { Input } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const SearchBox = ({ className, placeholder }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const inputRef = useRef();
  const { t } = useTranslation();
  const handleSearchKeyPress = event => {
    if (event.key === 'Enter') {
      dispatch(templateActions.search({ q: inputRef.current.value }, true));
      history.push(`/home/templates/tags/${inputRef.current.value}`);
    }
  };
  const placeHolder = placeholder || `${t('search')}...`;
  return (
    <Input
      className={`searchField ${className}`}
      // icon="search"
      placeholder={placeHolder}
      onKeyPress={handleSearchKeyPress}
    >
      <input ref={inputRef} />
    </Input>
  );
};

SearchBox.propTypes = {
  className: PropTypes.string,
};

export default SearchBox;
